(function () {
  'use strict';

  /* @ngdoc object
   * @name users.list
   * @description
   *
   */
  angular
    .module('users.list', [
      'ui.router'
    ]);
}());
